import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { BlockingWarningDialogData } from '../error-mesage.actions';

@Component({
  selector: 'daas-consulting-shared-blocking-warning-dialog',
  templateUrl: './blocking-warning-dialog.component.html',
  styleUrl: './blocking-warning-dialog.component.scss',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlockingWarningDialogComponent {
  readonly data: BlockingWarningDialogData;

  readonly #store: Store;
  readonly #dialogRef: MatDialogRef<BlockingWarningDialogComponent>;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BlockingWarningDialogData,
    store: Store,
    dialogRef: MatDialogRef<BlockingWarningDialogComponent>
  ) {
    this.data = data;
    this.#store = store;
    this.#dialogRef = dialogRef;
  }

  handleNavigate(): void {
    this.#dialogRef.close();
    this.#store.dispatch(new Navigate(this.data.actionPath));
  }

  handleClose(): void {
    this.#dialogRef.close();
  }
}
